import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines class names using clsx and tailwind-merge.
 *
 * This utility merges Tailwind CSS classes intelligently, handling conflicts
 * between utility classes (e.g., `p-2` and `p-4` will result in `p-4`).
 *
 * @param inputs - Class values to combine (strings, arrays, objects, etc.)
 * @returns A merged class string with Tailwind conflicts resolved
 *
 * @example
 * ```tsx
 * cn('p-2', 'p-4') // Returns 'p-4'
 * cn('text-red-500', isActive && 'text-blue-500') // Conditional classes
 * cn('base-class', { 'conditional-class': condition }) // Object syntax
 * ```
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
